import React, { useState, type JSX } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { navigiereExtern, oeffneExtern } from '../shared/navigation';

type Props = {
  readonly disabled: boolean;
  readonly pdfUrl: string | null;
  readonly vxsUrl: string | null;
};

export function istKalkulationsdateiVerfuegbar(pdfUrl: string | null, vxsUrl: string | null): boolean {
  return pdfUrl !== null || vxsUrl !== null;
}

export function vxsDownloadDateiname(vorgangsnummer: string | null | undefined): string {
  return `${vorgangsnummer ?? 'kalkulation'}.xml`;
}

export function KalkulationsdateiButton({ disabled, pdfUrl, vxsUrl }: Props): JSX.Element {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleOpenPdf = () => {
    handleMenuClose();
    if (pdfUrl) {
      oeffneExtern(pdfUrl);
    }
  };

  const handleDownloadVxs = () => {
    handleMenuClose();
    if (vxsUrl) {
      navigiereExtern(vxsUrl);
    }
  };

  return (
    <>
      <Button
        fullWidth
        disabled={disabled}
        color="primary"
        variant="contained"
        endIcon={<ArrowDropDownIcon />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        data-testid="kalkulationsdatei-button"
      >
        Kalkulationsdatei
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        <MenuItem disabled={!pdfUrl} onClick={handleOpenPdf} data-testid="kalkulationsdatei-pdf">
          PDF öffnen
        </MenuItem>
        <MenuItem disabled={!vxsUrl} onClick={handleDownloadVxs} data-testid="kalkulationsdatei-vxs">
          VXS/XML herunterladen
        </MenuItem>
      </Menu>
    </>
  );
}
